import React from 'react'
import TagBadge from './TagBadge'

const COLORS = { 'подписан': 'blue', signed: 'blue', 'оплачен': 'green', paid: 'green', 'на подписании': 'amber', pending: 'amber', 'не оплачен': 'amber', 'не подписан': 'grey', unsigned: 'grey' }

export default function ActStatusBadge({ status, variant, children, className = '' }) {
  const label = status || children || 'Не указан'
  const color = COLORS[String(status || variant || children || '').trim().toLowerCase()] || 'grey'
  return <TagBadge variant={color} className={className}>{label}</TagBadge>
}
